<template>
  <div class="f-left-user">
    <div class="f-left-user-img">
      <!-- <img src="~@/assets/images/avatar_default.png" /> -->
      <img
        src="http://safety-education-file.oss-cn-shenzhen.aliyuncs.com/schoolFaceFile/9a641276607541489619c5abf9cb4391.png?x-oss-process=style/compression"
      />
    </div>
    <div class="f-left-user-text">
      <span>李世航</span>
      <i>2023-09-16 18:55:28</i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      title: "",
    };
  },
  mounted() {},
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.f-left-user {
  display: flex;
  margin-bottom: 20px;
  .f-left-user-img {
    width: 50px;
    height: 50px;
    line-height: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .f-left-user-text {
    color: #fff;
    font-size: 20px;
    display: flex;
    flex: 1;
    padding-left: 15px;
    line-height: 50px;
    span {
      flex: 1;
    }
    i {
      text-align: right;
      font-style: normal;
    }
  }
}
</style>
